import { AccommodationRoomType } from "Bands/types";
import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";

const { accommodationBlock: blockCopy } = copy;

interface Props {
  minimumQuantity: number;
  minimumPeoplePerRoom: number;
}

export const getFields = ({
  minimumQuantity = 1,
  minimumPeoplePerRoom = 1,
}: Props): IFormFields => [
  {
    name: "name",
    label: blockCopy.create.roomsBlock.fields.name,
    type: IFieldType.select,
    options: Object.keys(AccommodationRoomType).map(type => ({
      value: type,
      label: AccommodationRoomType[type as keyof typeof AccommodationRoomType],
    })),
    placeholder: blockCopy.create.roomsBlock.placeholders.name,
    style: {
      gridColumn: "span 4",
    },
    isCreatable: true,
    isSearchable: true,
    validation: {
      required: blockCopy.create.roomsBlock.errors.required,
    },
  },
  {
    name: "quantity",
    label: blockCopy.create.roomsBlock.fields.quantity,
    type: IFieldType.number,
    decimalScale: 0,
    style: {
      gridColumn: "span 1",
    },
    validation: {
      required: blockCopy.create.roomsBlock.errors.required,
      validate: (value: number) =>
        value >= minimumQuantity ||
        blockCopy.create.roomsBlock.errors.mustBeGreaterThan.replace(
          "%v",
          minimumQuantity.toString()
        ),
    },
  },
  {
    name: "peoplePerRoom",
    label: blockCopy.create.roomsBlock.fields.peoplePerRoom,
    type: IFieldType.number,
    decimalScale: 0,
    style: {
      gridColumn: "span 1",
    },
    validation: {
      required: blockCopy.create.roomsBlock.errors.required,
      validate: (value: number) =>
        value >= minimumPeoplePerRoom ||
        blockCopy.create.roomsBlock.errors.mustBeGreaterThan.replace(
          "%v",
          minimumPeoplePerRoom.toString()
        ),
    },
  },
];
